import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import EntityCreateForm from "./-form";
import { EntityCrumbs } from "./-crumbs";

export const Route = createFileRoute("/_private/_admin/entity/create")({
  component: EntityCreatePage,
});

function EntityCreatePage() {
  return (
    <div>
      <title>Create Entity - Legrande Health Portal</title>
      <EntityCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>Create Entity</CardTitle>
          <CardDescription>Enter entity details below.</CardDescription>
        </CardHeader>
        <CardContent>
          <EntityCreateForm />
        </CardContent>
      </Card>
    </div>
  );
}
